export default {
  rooms: {
    // [presentationId]: { id: [roomId] }
    by_ua: { id: '0' },
    fr_be_at: { id: '0' },
    ge_mx_id: { id: '0' },
  },
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/addons/chat/presentation.js